<template>
  <v-card flat>
    <v-overlay :value="isLoading()">
      <v-progress-circular indeterminate size="100" />
    </v-overlay>
    <v-card-text>
      <list-user />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ListUser from "@/components/ListUser";

export default {
  name: "VueUser",
  components: {
    ListUser,
  },
  computed: {
    ...mapGetters({
      usersIsLoading: "user/list/isLoading",
      userCreateIsLoading: "user/create/isLoading",
      userUpdateIsLoading: "user/update/isLoading",
    }),
  },
  methods: {
    isLoading() {
      return (
        this.usersIsLoading ||
        this.userCreateIsLoading ||
        this.userUpdateIsLoading
      );
    },
  },
};
</script>

<style scoped></style>
